// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';
import type Product from '../../../Product';
import { generateProduct } from '../../helpers';

export default class Purchase extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return this.data.hasOwnProperty('transactionId') &&
      this.data.hasOwnProperty('coupon') &&
      this.data.hasOwnProperty('totalExVat') &&
      this.data.hasOwnProperty('shippingExVat') &&
      this.data.hasOwnProperty('tax') &&
      this.data.hasOwnProperty('discountExVat') &&
      this.data.hasOwnProperty('feeExVat') &&
      Array.isArray(this.data.products) &&
      this.data.products.length;
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    super.dispatch();
    this.push({
      event: EventNames.PURCHASE,
      ecommerce: {
        currency: window.currency,
        transaction_id: this.data.transactionId,
        coupon: this.data.coupon,
        value: this.data.totalExVat,
        shipping: this.data.shippingExVat,
        tax: this.data.tax,
        items: this.data.products.map((product: Product) => generateProduct(product)),
        discount_coupon_total: this.data.discountExVat,
        payment_costs: this.data.feeExVat,
        login_status: this.data.login_status,
        account_status: this.data.account_status,
        delivery_method: this.data.delivery_method,
        purchase_history: this.data.purchase_history,
        user_id: this.data.user_id
      }
    });
  }
}
